var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 42C42.3137 42 45 39.3137 45 36V20C45 16.6863 42.3137 14 39 14H37V10C37 7.79086 35.2091 6 33 6H11C7.68629 6 5 8.68629 5 12L5 22C5 23.1046 5.89543 24 7 24C8.10457 24 9 23.1046 9 22V17.6586C9.62556 17.8797 10.2987 18 11 18H39C40.1046 18 41 18.8954 41 20V22H38C34.6863 22 32 24.6863 32 28C32 31.3137 34.6863 34 38 34H41V36C41 37.1046 40.1046 38 39 38H27C25.8954 38 25 38.8954 25 40C25 41.1046 25.8954 42 27 42H39ZM33 14H11C9.89543 14 9 13.1046 9 12C9 10.8954 9.89543 10 11 10H33V14ZM38 26H41V30H38C36.8954 30 36 29.1046 36 28C36 26.8954 36.8954 26 38 26Z",
    fill: "#d9ff02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 28C15 26.8954 14.1046 26 13 26C11.8954 26 11 26.8954 11 28V33H6C4.89543 33 4 33.8954 4 35C4 36.1046 4.89543 37 6 37H11V42C11 43.1046 11.8954 44 13 44C14.1046 44 15 43.1046 15 42V37H20C21.1046 37 22 36.1046 22 35C22 33.8954 21.1046 33 20 33H15V28Z",
    fill: "#d9ff02"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWallet);
export default __webpack_public_path__ + "static/media/add-wallet.9738dadc.svg";
export { ForwardRef as ReactComponent };